import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const ExportButton = ({
  onCSV,
  onXLS,
  onPDF,
  onXML,
  onICS,
  onJSON,
  canUsePremiumFormats = false,
  isLoggedIn = false,
  forceOpen = false,
  buttonStyle = {},
  dropdownTop = 30
}) => {

  const { t } = useTranslation()

  const [open, setOpen] = useState(forceOpen)

useEffect(() => {
  if (forceOpen) {
    setOpen(true)
  }
}, [forceOpen])

  return (
    <div style={{ position:'relative', display:'inline-block' }}>

      <button
        onMouseEnter={(e)=>{
          if (!open) e.currentTarget.style.background='#2da9a4'
        }}
        onMouseLeave={(e)=>{
          if (!open){
            e.currentTarget.style.background='#f5f5f5'
            e.currentTarget.style.transform='scale(1)'
            e.currentTarget.style.boxShadow='0 1px 8px rgba(0,0,0,0.30)'
          }
        }}
        onMouseDown={(e)=>{
          e.currentTarget.style.transform='scale(0.96)'
          e.currentTarget.style.boxShadow='0 0px 4px rgba(0,0,0,0.25)'
        }}
        onMouseUp={(e)=>{
          e.currentTarget.style.transform='scale(1)'
          e.currentTarget.style.boxShadow='0 1px 8px rgba(0,0,0,0.30)'
        }}
        onClick={(e)=>{
          const next = !open
          setOpen(next)
          e.currentTarget.style.background = next ? '#2da9a4' : '#f5f5f5'
        }}
	style={{
 	 background: open ? '#2da9a4' : '#f5f5f5',
 	 border:'1px solid #107c6b',
 	 borderRadius:6,
	  height:24,
 	 padding:'0 10px',
 	 cursor:'pointer',
 	 fontWeight:700,
 	 boxShadow:'0 1px 8px rgba(0,0,0,0.30)',
 	 transition:'transform 0.05s ease, box-shadow 0.1s ease',
 	 marginTop:5,
 	 ...buttonStyle
	}}
      >
        {t('TRIPLOG.BUTTON_EXPORT')}
      </button>

      {open && (

        <div
          style={{
            position:'absolute',
            top: dropdownTop,
            right:0,
            width:'100%',
            background:'#f5f5f5',
            border:'1px solid #107c6b',
            borderRadius:6,
            boxShadow:'0 1px 8px rgba(0,0,0,0.30)',
            zIndex:1000,
            overflow:'hidden'
          }}
        >

          <div
            onClick={()=>{setOpen(false);onCSV()}}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor:'pointer',
              fontWeight:700
            }}
          >
            CSV
          </div>

          <div
            onClick={()=>{setOpen(false);onXLS()}}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor:'pointer',
              fontWeight:700
            }}
          >
            XLS
          </div>

          <div
            onClick={()=>{setOpen(false);onPDF()}}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor:'pointer',
              fontWeight:700
            }}
          >
            PDF
          </div>

          <div
            onClick={()=>{
              if (!isLoggedIn) return
              setOpen(false)
              onXML()
            }}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor: isLoggedIn ? 'pointer' : 'not-allowed',
              fontWeight:700,
              opacity: isLoggedIn ? 1 : 0.45
            }}
          >
            XML
          </div>

          <div
            onClick={()=>{
              if (!isLoggedIn || !canUsePremiumFormats) return
              setOpen(false)
              onICS()
            }}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor: isLoggedIn && canUsePremiumFormats ? 'pointer' : 'not-allowed',
              fontWeight:700,
              opacity: isLoggedIn && canUsePremiumFormats ? 1 : 0.45
            }}
          >
            ICS
          </div>

          <div
            onClick={()=>{
              if (!isLoggedIn || !canUsePremiumFormats) return
              setOpen(false)
              onJSON()
            }}
            onMouseEnter={(e)=>{e.currentTarget.style.background='#c8e1e1'}}
            onMouseLeave={(e)=>{e.currentTarget.style.background='#f5f5f5'}}
            style={{
              padding:'6px 12px',
              cursor: isLoggedIn && canUsePremiumFormats ? 'pointer' : 'not-allowed',
              fontWeight:700,
              opacity: isLoggedIn && canUsePremiumFormats ? 1 : 0.45
            }}
          >
            JSON
          </div>

        </div>

      )}

    </div>
  )
}

export default ExportButton